import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import LazyCatalogImage from "./LazyCatalogImage";
import { useI18n } from "@/i18n/I18nProvider";
import { formatSlotQuantity, placementId } from "./vipSimulatorUtils";

export default function KitItemCard({
    placement,
    entry,
    onRemoveFromKit,
    draggable = true,
    compact = false,
    onDoubleClick,
    hintTitle,
}) {
    const { t, item, lang } = useI18n();
    const displayName = item(entry.name);
    const qEn = !!entry.quantityEnabled;
    const qty = qEn ? placement.quantity : 1;

    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
        id: placementId(placement.instanceId),
        disabled: !draggable,
        data: { type: "placement", placement, entry },
    });

    const style = transform
        ? {
              transform: CSS.Translate.toString(transform),
              zIndex: isDragging ? 50 : undefined,
              opacity: isDragging ? 0.65 : 1,
          }
        : undefined;

    return (
        <div
            ref={setNodeRef}
            style={style}
            className={`vip-sim-item vip-sim-item--kit ${compact ? "vip-sim-item--kit-compact" : ""} ${draggable ? "vip-sim-item--draggable" : ""}`}
            {...(draggable ? { ...listeners, ...attributes } : {})}
            title={hintTitle || displayName}
            onDoubleClick={(e) => {
                e.stopPropagation();
                onDoubleClick?.();
            }}
        >
            <div className="vip-sim-item__img-wrap">
                {entry.icon ? (
                    <LazyCatalogImage
                        className="vip-sim-item__img"
                        src={entry.icon}
                        fallbacks={entry.iconCandidates}
                        alt=""
                    />
                ) : entry.emoji ? (
                    <span className="vip-sim-item__emoji">{entry.emoji}</span>
                ) : null}
                <span className="vip-sim-item__slot-qty">x{formatSlotQuantity(qty, lang)}</span>
            </div>
            {!compact ? <div className="vip-sim-item__name">{displayName}</div> : null}
            {onRemoveFromKit ? (
                <button
                    type="button"
                    className="vip-sim-item__remove"
                    aria-label={t("simulator.item.remove")}
                    onPointerDown={(e) => e.stopPropagation()}
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemoveFromKit(placement.instanceId);
                    }}
                >
                    ×
                </button>
            ) : null}
        </div>
    );
}


